<template>
  <section class="ncrm-privacy-card ncrm-privacy-card--compact">
    <header class="ncrm-privacy-card__header">
      <h2 class="ncrm-privacy-card__title">{{ $t(`${copyKey}.title.${view}`) }}</h2>
      <p class="ncrm-privacy-card__subtitle">{{ $t(`${copyKey}.subtitle`, { count: total }) }}</p>
    </header>
    <NcrmPrivacyStackedBar :segments="segments" :height="12" :aria-label="ariaLabel" track />
    <div class="ncrm-privacy-breakdown__rows">
      <button
        v-for="row in rows.present"
        :key="row.state"
        type="button"
        class="ncrm-privacy-breakdown__row"
        @click="$emit('drill-down', row.state)"
      >
        <span class="ncrm-privacy-dot" :style="{ background: colors[row.state] }" />
        <span>{{ $t(`ncrm.contacts.dataProtection.states.${row.state}`) }}</span>
        <strong class="ncrm-privacy-breakdown__count">{{ row.count }}</strong>
        <span class="ncrm-privacy-card__muted ncrm-privacy-breakdown__pct">{{ row.pct }}%</span>
        <v-icon size="16" class="ncrm-privacy-breakdown__chevron">mdi-chevron-right</v-icon>
      </button>
    </div>
    <p v-if="rows.empty.length" class="ncrm-privacy-card__muted">
      {{ $t(`${copyKey}.none`, { states: emptyLabels }) }}
    </p>
  </section>
</template>

<script>
import NcrmPrivacyStackedBar from "./NcrmPrivacyStackedBar.vue";
import { SUMMARY_STATES } from "./privacyWorkspaceContracts.mjs";
import { SUMMARY_STATE_COLORS, breakdownRows } from "./privacyDashboardModel.mjs";

export default {
  name: "NcrmPrivacyBreakdownCard",
  components: { NcrmPrivacyStackedBar },
  props: {
    view: { type: String, default: "persons" },
    byState: { type: Object, default: () => ({}) },
    total: { type: Number, default: 0 },
  },
  emits: ["drill-down"],
  computed: {
    copyKey() { return "ncrm.contacts.dataProtection.workspace.breakdown"; },
    colors() { return SUMMARY_STATE_COLORS; },
    rows() { return breakdownRows(this.byState, this.total, SUMMARY_STATES); },
    segments() {
      return this.rows.present.map((row) => ({
        key: row.state,
        pct: row.widthPct,
        color: SUMMARY_STATE_COLORS[row.state],
        title: `${this.stateLabel(row.state)}: ${row.count}`,
      }));
    },
    emptyLabels() { return this.rows.empty.map((state) => this.stateLabel(state)).join(", "); },
    ariaLabel() {
      return this.rows.present.map((row) => `${this.stateLabel(row.state)} ${row.count}`).join(", ");
    },
  },
  methods: {
    stateLabel(state) { return this.$t(`ncrm.contacts.dataProtection.states.${state}`); },
  },
};
</script>

<style scoped>
.ncrm-privacy-breakdown__rows { display: flex; flex-direction: column; }
.ncrm-privacy-breakdown__row {
  display: grid; grid-template-columns: 12px minmax(0, 1fr) 40px 44px 16px; gap: 10px; align-items: center;
  min-height: 42px; padding: 0 4px; border: 0; border-top: 1px solid rgba(var(--v-theme-on-surface), 0.08);
  background: transparent; color: inherit; font: inherit; font-size: 14px; text-align: left; cursor: pointer;
}
.ncrm-privacy-breakdown__row:hover { background: rgba(var(--v-theme-primary), 0.04); }
.ncrm-privacy-breakdown__row:focus-visible { outline: 2px solid rgb(var(--v-theme-primary)); outline-offset: -2px; }
.ncrm-privacy-breakdown__count { text-align: right; }
.ncrm-privacy-breakdown__pct { text-align: right; }
.ncrm-privacy-breakdown__chevron { opacity: .5; }
</style>
